// HomePage layout styles — page background + compact section headers.

export const dashboardStyles = {
  container: {
    minHeight: '100vh',
    background: theme =>
      theme.palette.mode === 'dark' ? '#0f0f1a' : '#f4f5f7',
    py: { xs: 2, md: 3 },
    px: { xs: 1, sm: 2 },
  },

  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    mb: 1.75,
  },

  sectionLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    flexShrink: 0,
  },

  sectionIconBox: {
    width: 26,
    height: 26,
    borderRadius: '7px',
    background: 'linear-gradient(135deg, rgba(58,90,240,0.18), rgba(58,90,240,0.08))',
    border: '1px solid rgba(58,90,240,0.22)',
    color: '#3a5af0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 1px 2px rgba(58,90,240,0.10)',
  },

  sectionTitle: {
    fontWeight: 700,
    fontSize: '15px',
    color: '#0f1424',
    letterSpacing: '-0.2px',
  },

  sectionDivider: {
    flexGrow: 1,
    height: '1px',
    background: 'linear-gradient(90deg, rgba(58,90,240,0.18), rgba(58,90,240,0))',
    ml: 1,
  },
};
